import {Injectable} from '@angular/core';
import {ITask, ITaskBase} from "../../task/shared/models/task.model";

@Injectable({
    providedIn: 'root'
})
export class TaskService {

    getTasksData(): ITaskBase[] {
        return [
            {
                id: '1004',
                no: 'TK-9',
                title: 'Task Title',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'review',
                state: 'received',
                targetDate: '11.08.2025',
            },
            {
                id: '1000',
                no: 'ITA-7',
                title: 'Göerv',
                description: 'Product Description',
                recipient: 'Janakan J',
                status: 'open',
                state: 'received',
                targetDate: '12.12.2024',
            },
            {
                id: '1001',
                no: 'TK-7',
                title: 'Initial flutter project',
                description: 'Product Description',
                recipient: 'Helga A',
                status: 'review',
                state: 'sent',
                targetDate: '03.06.2024',
            },
            {
                id: '1002',
                no: 'ITA-11',
                title: 'Tİtle of project',
                description: 'Product Description',
                recipient: 'Elom M',
                status: 'done',
                state: 'backlog',
                targetDate: '12.05.2023',
            },
            {
                id: '1003',
                no: 'ITA-13',
                title: 'Anorhet project title',
                description: 'Product Descripton',
                recipient: 'Hans B',
                status: 'open',
                state: 'sent',
                targetDate: '23.03.2022',
            },
            {
                id: '1004',
                no: 'TK-9',
                title: 'Göerv',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'done',
                state: 'received',
                targetDate: '11.08.2024',
            },
            {
                id: '1000',
                no: 'ITA-7',
                title: 'Göerv',
                description: 'Product Description',
                recipient: 'Janakan J',
                status: 'blocked',
                state: 'backlog',
                targetDate: '12.12.2024',
            },
            {
                id: '1001',
                no: 'TK-7',
                title: 'Initial flutter project',
                description: 'Product Description',
                recipient: 'Helga A',
                status: 'progress',
                state: 'sent',
                targetDate: '03.06.2024',
            },
            {
                id: '1002',
                no: 'ITA-11',
                title: 'Tİtle of project',
                description: 'Product Description',
                recipient: 'Elom M',
                status: 'progress',
                state: 'received',
                targetDate: '12.05.2023',
            },
            {
                id: '1003',
                no: 'ITA-13',
                title: 'Anorhet project title',
                description: 'Product Descripton',
                recipient: 'Hans B',
                status: 'done',
                state: 'received',
                targetDate: '23.03.2022',
            },
            {
                id: '1004',
                no: 'TK-9',
                title: 'Göerv',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'blocked',
                state: 'sent',
                targetDate: '11.08.2025',
            },
            {
                id: '1004',
                no: 'TK-9',
                title: 'Task Title',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'review',
                state: 'received',
                targetDate: '11.08.2025',
            },
            {
                id: '1004',
                no: 'TK-9',
                title: 'Another Task Title',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'progress',
                state: 'backlog',
                targetDate: '11.08.2025',
            },
            {
                id: '1004',
                no: 'ITK-9',
                title: 'Another Task Title 2',
                description: 'Product Description',
                recipient: 'Hans C',
                status: 'progress',
                state: 'sent',
                targetDate: '11.08.2025',
            },
        ];
    }

    getTasksWithSubtasksData(): ITask[] {
        return [
            {
                id: '1004',
                no: 'TK-9',
                title: 'Task Title',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'review',
                state: 'received',
                targetDate: '11.08.2025',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'blocked',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'progress',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1000',
                no: 'ITA-7',
                title: 'Göerv',
                description: 'Product Description',
                recipient: 'Janakan J',
                status: 'done',
                state: 'received',
                targetDate: '12.12.2024',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'done',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'open',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-21',
                        title: 'Another project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'blocked',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1001',
                no: 'TK-7',
                title: 'Initial flutter project',
                description: 'Product Description',
                recipient: 'Helga A',
                status: 'open',
                state: 'sent',
                targetDate: '03.06.2024',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'review',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'done',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1002',
                no: 'ITA-11',
                title: 'Tİtle of project',
                description: 'Product Description',
                recipient: 'Elom M',
                status: 'progress',
                state: 'backlog',
                targetDate: '12.05.2023',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'review',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'progress',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1003',
                no: 'ITA-13',
                title: 'Anorhet project title',
                description: 'Product Descripton',
                recipient: 'Hans B',
                status: 'blocked',
                state: 'sent',
                targetDate: '23.03.2022',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'done',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'done',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1004',
                no: 'TK-9',
                title: 'Göerv',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'open',
                state: 'received',
                targetDate: '11.08.2024',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'done',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'progress',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1000',
                no: 'ITA-7',
                title: 'Göerv',
                description: 'Product Description',
                recipient: 'Janakan J',
                status: 'open',
                state: 'sent',
                targetDate: '12.12.2024',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'blocked',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'progress',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1001',
                no: 'TK-7',
                title: 'Initial flutter project',
                description: 'Product Description',
                recipient: 'Helga A',
                status: 'done',
                state: 'backlog',
                targetDate: '03.06.2024',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'done',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'progress',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1002',
                no: 'ITA-11',
                title: 'Tİtle of project',
                description: 'Product Description',
                recipient: 'Elom M',
                status: 'blocked',
                state: 'received',
                targetDate: '12.05.2023',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'blocked',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'open',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1003',
                no: 'ITA-13',
                title: 'Anorhet project title',
                description: 'Product Descripton',
                recipient: 'Hans B',
                status: 'done',
                state: 'backlog',
                targetDate: '23.03.2022',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'review',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'open',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1004',
                no: 'TK-9',
                title: 'Göerv',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'blocked',
                state: 'sent',
                targetDate: '11.08.2024',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'blocked',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'progress',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1004',
                no: 'TK-9',
                title: 'Task Title',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'review',
                state: 'sent',
                targetDate: '11.08.2025',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'blocked',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'progress',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1004',
                no: 'TK-9',
                title: 'Another Task Title',
                description: 'Product Description',
                recipient: 'Bill G',
                status: 'progress',
                state: 'received',
                targetDate: '11.08.2025',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'blocked',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'progress',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
            {
                id: '1004',
                no: 'ITK-9',
                title: 'Another Task Title 2',
                description: 'Product Description',
                recipient: 'Hans C',
                status: 'progress',
                state: 'sent',
                targetDate: '11.08.2025',
                subtasks: [
                    {
                        id: '1101',
                        no: 'SUB-TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'blocked',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                    {
                        id: '1201',
                        no: 'TK-7',
                        title: 'Initial flutter project',
                        description: 'Product Description',
                        recipient: 'Helga A',
                        status: 'progress',
                        state: 'OPEN',
                        targetDate: '03.06.2024',
                    },
                ]
            },
        ]
    }

    getTasksMini() {
        return Promise.resolve(this.getTasksData().slice(0, 5));
    }

    getTasksSmall() {
        return Promise.resolve(this.getTasksData().slice(0, 10));
    }

    getTasks() {
        return Promise.resolve(this.getTasksData());
    }

    getTasksWithSubtasksSmall() {
        return Promise.resolve(this.getTasksWithSubtasksData().slice(0, 10));
    }

    getTasksWithSubtasks() {
        return Promise.resolve(this.getTasksWithSubtasksData());
    }
}
